import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';
import {SellerDashboardComponent} from './seller-dashboard.component';

export const sellerDashboardRoute: Routes = [
    {
        path: 'dashboard',
        component: SellerDashboardComponent,
        data: {
            authorities: [ 'ROLE_SELLER' ],
            pageTitle: 'deviceConfigurerServiceApp.seller.dashboard.title'
        }
    },
    //{
    //    path: 'dashboard/:id',
    //    component: SellerDashboardComponent,
    //    data: {
    //        authorities: [ 'ROLE_SELLER' ],
    //        pageTitle: 'deviceConfigurerServiceApp.seller.dashboard.title'
    //    }
    //}
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/dashboard/seller-dashboard/seller-dashboard.route.ts